// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3tPMw","col":"Table_col__3T-6_","fulfillmentStatus":"Table_fulfillmentStatus__3tFKu","emailCol":"Table_emailCol__XNxzr"};